import { computed } from 'vue'
import { useStore } from '@/common/utils/store'
import { convertCellEventList } from '@/common/converter/convert-event-list'
import { HOME_API_ROUTE_LIST } from '@/common/resources/router.const'
import { useRouter } from 'vue-router/composables'
import { FETCH_CATEGORY } from '@/common/utils/store.const'

export const useCategory = () => {
  const store = useStore()
  const router = useRouter()

  const categoryComp = computed(() => {
    return store.getters.category
  })
  const categoryListComp = computed(() => {
    return getCategoryList(categoryComp.value)
  })

  const getCategoryList = (_category) => {
    if (!_category) return []
    const { categoryList } = _category
    return categoryList.map((category) => {
      const { code, elementList } = category
      return {
        code,
        text: elementList[0].property?.text,
        eventList: convertCellEventList(elementList),
      }
    })
  }

  const init = async () => {
    const isHome = HOME_API_ROUTE_LIST.includes(router.currentRoute.name)

    if (!isHome && !categoryComp.value) {
      await store.dispatch(FETCH_CATEGORY)
    }
  }
  return {
    categoryComp,
    categoryListComp,
    init,
  }
}
